module.exports = __webpack_public_path__ + "static/media/errorimg.df4695f0.svg";